import type { TreeType } from '@octopus-do/octopus-project-core'

// Compact (OCT-5366) is drawn by the editor only; every other reader of
// settings.tree keeps seeing it as the default map layout.
export const getBaseTreeType = (tree: string): TreeType =>
  tree === 'matrix' ? 'matrix' : 'map'
